import { Delivery, DeliveryStatus } from '../api/models/deliveries';
import i18next from '../i18next';
import { Location, SearchLocation } from '../api/models/locations';
import { DirectionType } from '../components/Map';

export const canBeCanceled = (status: DeliveryStatus) => {
  return [DeliveryStatus.Pending, DeliveryStatus.Assigned].includes(status);
};

export const getDirectionType = (status: Delivery['status']) => {
  switch (status) {
    case DeliveryStatus.Assigned:
      return DirectionType.DriverPickup;
    case DeliveryStatus.AtPickup:
      return DirectionType.DriverAtPickupNow;
    case DeliveryStatus.InProgress:
      return DirectionType.DriverDropOff;
  }
};

export const getDropOffName = (delivery: Delivery) =>
  delivery.dropOffLocation?.location
    ? delivery.dropOffLocation.name
    : i18next.t('deliveries.dropoffLocation.noCoordinates');

export const getDistance = (delivery: Delivery) =>
  delivery.distance && `${Math.round(delivery.distance)} ${i18next.t('general.km')}`;

export const getPassengerName = (delivery: Delivery) =>
  delivery.passenger && `${delivery.passenger.firstName} ${delivery.passenger.lastName}`;

export const isCanceled = (status: DeliveryStatus) => {
  return [DeliveryStatus.Cancelled, DeliveryStatus.CNF].includes(status);
};

export const getDropOffLocationTitle = (dropOff: SearchLocation): string => {
  let result = dropOff.formattedAddress;
  if (dropOff.area) {
    if (dropOff.building) {
      result = `${dropOff.building}, ${dropOff.area}`;
    } else if (dropOff.formattedAddress) {
      result = `${dropOff.formattedAddress}, ${dropOff.area}`;
    }
  }
  return result || `${dropOff.location?.lat}, ${dropOff.location?.lng}`;
};

export const getPickupLocationTitle = (pickup: Location): string =>
  `${pickup.nickname} - ${pickup.building} - ${pickup.street} - ${pickup.area} - ${pickup.city}`;
